import { SearchViewModel } from '@models/module/grid';
import { StatusColumnType } from '@shared/components/data-list/common';

export interface AccessLogModel {
  entityInstanceId: number;
  userId: number;
  user: string;
  accessOn: string;
  state: string;
  stateColor: string;
  stateTextColor: string;
  stateType: number;
}

export type AccessLogTableRow = AccessLogModel & {
  state_name: StatusColumnType;
};

export type AccessLogRequest = {
  entityInstanceId: number;
  contractId: number;
  body: SearchViewModel;
};
